import React from "react";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { Space, Row, Button } from "@masterteam/mt-design-react";

import ParameterItem from "./Item";
import ReadOnlyItem from "./ReadOnlyItem";

function ParametersField({
  isEditMode,
  isReadOnly,
  parametersList = null,
  isChangeRequest,
}) {
  const intl = useIntl();
  const { setFieldValue, values, errors } = useFormikContext();

  const data = parametersList?.length ? parametersList : values.Parameters;

  const addItem = () => {
    setFieldValue(`Parameters[${values.Parameters?.length}]`, {
      ParameterName: "",
      Description: "",
    });
  };

  const removeItem = (index) => {
    const newSteps = [...values.Parameters];
    if (newSteps?.[index]?.ParameterName) {
      setFieldValue("Formula", []);
    }
    newSteps.splice(index, 1);
    setFieldValue("Parameters", newSteps);
  };

  return (
    <Space direction="vertical" size="medium">
      <Row size="small" justify="between">
        <h3>
          {intl.formatMessage(
            { id: "common.list" },
            { value: intl.formatMessage({ id: "kpi.parameters" }) }
          )}
        </h3>
        {isChangeRequest && isReadOnly ? null : (
          <Button
            onClick={addItem}
            disabled={errors?.Parameters || isEditMode || isReadOnly}
          >
            {intl.formatMessage({ id: "kpi.add-parameter" })}
          </Button>
        )}
      </Row>

      <Space size="medium" direction="vertical">
        {isChangeRequest && isReadOnly
          ? data?.map((item, index) => (
              <ReadOnlyItem
                key={index}
                index={index}
                removeItem={removeItem}
                isEditMode={isEditMode}
                isReadOnly={isReadOnly}
                errors={errors.Parameters?.[index]}
                data={item}
              />
            ))
          : data?.map((_, index) => (
              <ParameterItem
                key={index}
                index={index}
                removeItem={removeItem}
                isEditMode={isEditMode}
                isReadOnly={isReadOnly}
                errors={errors.Parameters?.[index]}
              />
            ))}
      </Space>
    </Space>
  );
}

export default ParametersField;
